import { appActions } from 'app/app.actions';
import { createCommands, useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export const searchCommands = createCommands([
  {
    group: 'search',
    label: 'Open search input',
    name: 'openSearchInput',
    description: 'Opens the search input in the top bar',
    keyboard: { keybindings: [{ binding: [[], 'Slash'] }] },
    useRegisterHandler: () => {
      const dispatch = useAppDispatch();

      useCommandHandler({
        name: 'search:openSearchInput',
        actionFn: () => {
          dispatch(
            appActions.showModal({ modal: { type: 'app:commandLauncher' } }),
          );
        },
      });
    },
  },
]);
